import React, { useState, useEffect } from "react";
import Loader from "../../Components/Common/Loader";
import { Col, Row, Card, CardHeader, CardBody, Button, Dropdown, DropdownItem, DropdownMenu, ButtonGroup, Input, Label, DropdownToggle, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import {getLocalStorageData, displayDateV1, convertDateFormate, getDateByName, getPercentageWithAlertV1,
    currencyFormatWithoutDecimalV1
} from "../../helpers/api_helper";
import { useSelector } from 'react-redux';


const OverallWidget = ({ leftFilter, mealPeriod, currency }) => {
    //const userOutletDetails = getLocalStorageData('userOutletDetails');
    //let currency=userOutletDetails?.currency??"$";

    const [showFull, setShowFull] = useState(false);
    const [widgetAjax, setWidgetAjax] = useState(true);
    const [widgetData, setWidgetData] = useState([]);
    const [ecomWidgets, setEcomWidgets] = useState([]);

    const selectedGroup = (localStorage.getItem('analyticsGroup') ? JSON.parse(localStorage.getItem('analyticsGroup')) : null);
     
    useEffect(() => {
       
        
        setWidgetAjax(true);
          postDataAPI({
            serviceName: 'groups_data',
            op: 'restarant_analytics_data',
            groupType: "all",
            leftFilter: leftFilter,
            mealPeriod: mealPeriod,
            group_id: selectedGroup.group_id || null
            }).then((response) => {
            if (response.status === "ok") {
                setWidgetData(response.data[0] || []);
                setWidgetAjax(false);
            } else {
                console.error("Failed to get group:", response);
                setWidgetAjax(false);
            }
            });
    
    }, [leftFilter, mealPeriod]);

    //console.log(widgetData);
    useEffect(() => {
        //currency = widgetData?.currency;
        const ecomWidgets1 = [
            {
                id: 1,
                label: "Total Covers",
                counter: !widgetAjax ? widgetData.covers:'',
                lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_cover_percent).toFixed(2)) :'',
                budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_cover_percent).toFixed(2)):'',
                fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_cover_percent).toFixed(2)):'',
                decimals: 0,
                prefix: "",
                suffix: "",
                separator: "",
                lybgClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                budbgClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                fcbgClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                lyArrowClass: (widgetData?.ly_cover_percent && Number(widgetData?.ly_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                budArrowClass: (widgetData?.bg_cover_percent && Number(widgetData?.bg_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                fcArrowClass: (widgetData?.fs_cover_percent && Number(widgetData?.fs_cover_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            },
            {
                id: 2,
                label: "Average Check",
                counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData.average_check, currency):'',
                lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_avg_check_percent).toFixed(2)):'',
                budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_avg_check_percent).toFixed(2)):'',
                fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_avg_check_percent).toFixed(2)):'',
                decimals: 0,
                prefix: "",
                suffix: "",
                separator: "",
                lybgClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                budbgClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                fcbgClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                lyArrowClass: (widgetData?.ly_avg_check_percent && Number(widgetData?.ly_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                budArrowClass: (widgetData?.bg_avg_check_percent && Number(widgetData?.bg_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                fcArrowClass: (widgetData?.fs_avg_check_percent && Number(widgetData?.fs_avg_check_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            },
            {
                id: 3,
                label: "Total Revenue",
                counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData.revenue, currency):'',
                lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_rev_percent).toFixed(2)):'',
                budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_rev_percent).toFixed(2)):'',
                fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_rev_percent).toFixed(2)):'',
                decimals: 0,
                prefix: "",
                suffix: "",
                separator: "",
                lybgClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                budbgClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                fcbgClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                lyArrowClass: (widgetData?.ly_rev_percent && Number(widgetData?.ly_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                budArrowClass: (widgetData?.bg_rev_percent && Number(widgetData?.bg_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                fcArrowClass: (widgetData?.fs_rev_percent && Number(widgetData?.fs_rev_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            },
            {
                id: 4,
                label: "Table Occupancy",
                counter: !widgetAjax ? widgetData?.table_occupancy+"%":'',
                lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_table_occupancy_percent).toFixed(2)):'',
                budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_table_occupancy_percent).toFixed(2)):'',
                fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_table_occupancy).toFixed(2)):'',
                decimals: 0,
                prefix: "",
                suffix: "",
                separator: "",
                lybgClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                budbgClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                fcbgClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "badge-soft-danger" : "badge-soft-success",
                lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                budArrowClass: (widgetData?.bg_table_occupancy_percent && Number(widgetData?.bg_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                fcArrowClass: (widgetData?.fs_table_occupancy && Number(widgetData?.fs_table_occupancy) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            },
            {
                id: 5,
                label: "Seat Occupancy",
                counter: !widgetAjax ? widgetData?.seat_occupancy+"%":'',
                lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_seat_occupancy_percent).toFixed(2)):'',
                budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_seat_occupancy_percent).toFixed(2)):'',
                fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_seat_occupancy_percent).toFixed(2)):'',
                decimals: 0,
                prefix: "",
                suffix: "",
                separator: "",
                lybgClass: (widgetData?.ly_seat_occupancy_percent && Number(widgetData?.ly_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                budbgClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                fcbgClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                lyArrowClass: (widgetData?.ly_table_occupancy_percent && Number(widgetData?.ly_table_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                budArrowClass: (widgetData?.bg_seat_occupancy_percent && Number(widgetData?.bg_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                fcArrowClass: (widgetData?.fs_seat_occupancy_percent && Number(widgetData?.fs_seat_occupancy_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            },
            {
                id: 6,
                label: "RevPASH",
                counter: !widgetAjax ? currencyFormatWithoutDecimalV1(widgetData?.revpash, currency):'',
                lyPer: !widgetAjax ? "vLY "+getPercentageWithAlertV1(Number(widgetData?.ly_revpash_percent).toFixed(2)):'',
                budPer: !widgetAjax ? "vBUD "+getPercentageWithAlertV1(Number(widgetData?.bg_revpash_percent).toFixed(2)):'',
                fcPer: !widgetAjax ? "vFC "+getPercentageWithAlertV1(Number(widgetData?.fs_revpash_percent).toFixed(2)):'',
                decimals: 0,
                prefix: "",
                suffix: "",
                separator: "",
                lybgClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                budbgClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                fcbgClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "badge-soft-danger" : "badge-soft-success",
                lyArrowClass: (widgetData?.ly_revpash_percent && Number(widgetData?.ly_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                budArrowClass: (widgetData?.bg_revpash_percent && Number(widgetData?.bg_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
                fcArrowClass: (widgetData?.fs_revpash_percent && Number(widgetData?.fs_revpash_percent) < 0) ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line",
            },
        ];
        setEcomWidgets(ecomWidgets1);
    }, [widgetData]);

    return (
        <>
        <Row id="Widget">
            <Card>
                <CardHeader className="ps-0 border-0 align-items-center d-flex">
                    <div
                        onClick={() => setShowFull(prev => !prev)}
                        className="arrow-toggle me-2"
                    >
                        <i className={`ri-arrow-${showFull ? "down" : "right"}-s-line fs-4`}></i>
                    </div>

                    <h4 className="card-title mb-0 flex-grow-1">Overall Group Performance</h4>                    
                </CardHeader>
                
                <CardBody className="p-0">
                {widgetAjax && <Loader />}    
                <div className={widgetAjax ? "opacity-0" : ""}>
                {!showFull ? (
                <Row id="overallLess">
                    {ecomWidgets.slice(0, 3).map((item, key) => (
                        <Col xl={4} key={key}>
                            <Card className="card-animate">
                                <CardBody>
                                    <div className="d-flex align-items-center">                            
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                            <div className="d-flex align-items-center mb-3">
                                                <h4 className="fs-4 flex-grow-1 mb-0">
                                                    <span className="counter-value me-1">
                                                        {item?.counter}
                                                    </span>
                                                </h4>
                                                
                                            </div>
                                            
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
                ) : (
                <Row id="overallFull">
                    {ecomWidgets.map((item, key) => (
                        <Col xl={4} key={key}>
                            <Card className="card-animate">
                                <CardBody>
                                    <div className="d-flex align-items-center">                            
                                        <div className="flex-grow-1 overflow-hidden">
                                            <p className="fw-medium text-muted text-truncate mb-3">{item.label}</p>
                                            <div className="d-flex align-items-center mb-3">
                                                <h4 className="fs-4 flex-grow-1 mb-0">
                                                    <span className="counter-value me-1">
                                                        {item?.counter}
                                                    </span>
                                                </h4>
                                                
                                            </div>
                                            <div className="d-flex flex-wrap justify-content-between">
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.lybgClass}><i className={"fs-10 align-middle me-1 "+item.lyArrowClass}></i>{item.lyPer}</span>
                                                </p>
                                                
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.budbgClass}><i className={"fs-10 align-middle me-1 "+item.budArrowClass}></i>{item.budPer}</span>
                                                </p>
                                                
                                                <p className="text-muted mb-0">
                                                    <span className={"fs-10 badge "+item.fcbgClass}><i className={"fs-10 align-middle me-1 "+item.fcArrowClass}></i>{item.fcPer}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
                )}
                </div> 
                </CardBody>
            </Card>
        </Row>
        </>
    );
};

export default OverallWidget;
